<h2 class="auth-header">Resetuj hasło</h2>

<div class="auth-alert auth-alert--warning" *ngIf="error">
  {{ error }}
</div>

<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <mat-form-field class="full-width-field">
    <input matInput type="email" placeholder="Email" formControlName="email">
    <!-- <mat-hint>Errors appear instantly!</mat-hint> -->
    <mat-error *ngIf="resetPasswordForm.controls['email'].hasError('email') && !resetPasswordForm.controls['emai'].hasError('required')">
      Wpisz poprawny aadres e-mail
    </mat-error>
    <mat-error *ngIf="resetPasswordForm.controls['email'].hasError('required')">
      Adres e-mail jest <strong>wymagany</strong>
    </mat-error>
  </mat-form-field>

  <!-- <ngx-recaptcha2 class="full-width-field" [siteKey]="capchaKey" (success)="handleSuccess($event)"
    formControlName="recaptchaKey">
  </ngx-recaptcha2> -->

<br>
<div class="text-center">
  <button mat-stroked-button type="submit">Zresetuj hasło</button>
  <br>
  <a class="btn--small" mat-button routerLink="/auth/login">Powrót do strony logowania</a>
</div>


</form>
